import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

export default function useSearchParams() {
  const location = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  return searchParams;
}
